import React from 'react';
import { propTypes, defaultProps } from "./MoneyPrediction.propTypes";

import {
  LineChart, XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Line,
  Legend, ResponsiveContainer,
} from 'recharts';

const chartMargin = {
  top: 5,
  right: 30,
  left: 20,
  bottom: 5,
};

class MoneyPrediction extends React.PureComponent {
  getPredictedData = (year, n = 10) => {
    const {
      startingPoint, monthSalary, monthExpenses, theoreticalExpenses, salaryYearlyGrowth,
      expensesYearlyGrowth, changedSalary, portfolioDiversity, retirementRule,
    } = this.props;
    const preds = [{
      year,
      totalBalance: startingPoint,
      cash: startingPoint * (portfolioDiversity.cash.share / 100),
      bonds: startingPoint * (portfolioDiversity.bonds.share / 100),
      stocks: startingPoint * (portfolioDiversity.stocks.share / 100),
    }];

    let salary = monthSalary;
    let monthlyExpenses = monthExpenses;

    for (let i = year + 1; i < year + n + 1; i += 1) {
      const previousYearStats = preds[preds.length - 1];
      const isRetired = retirementRule !== null && i >= retirementRule.inYear;
      
      let cashMadeByThisYear = 0;

      if (!isRetired) {
        cashMadeByThisYear = 12 * salary;
      }
      
      let thisYearContributionToBonds = 0;
      let thisYearContributionToStocks = 0; 

      if (!isRetired) {
        thisYearContributionToBonds = cashMadeByThisYear * (portfolioDiversity.bonds.share / 100);
        thisYearContributionToStocks = cashMadeByThisYear * (portfolioDiversity.stocks.share / 100);
      }

      let remainingCash = previousYearStats.cash + cashMadeByThisYear - thisYearContributionToBonds - thisYearContributionToStocks;

      // pay yearly expenses
      remainingCash -= monthExpenses * 12;

      // get dividends from previous year
      remainingCash += previousYearStats.stocks * portfolioDiversity.stocks.dividends;

      if (theoreticalExpenses) {
        if (`${i}` in theoreticalExpenses) {
          remainingCash -= theoreticalExpenses[i];
        }
      }

      // if is retired apply % widthdrawal rule
      if (isRetired) {
        remainingCash += (previousYearStats.stocks * retirementRule.percents);
      }
     

      // END YEAR

      // GROWTH

      // BONDS GROWTH
      const bondsNewValue = (previousYearStats.bonds + thisYearContributionToBonds) * (1 + portfolioDiversity.bonds.growth);

      // STOCKS GROWTH
      let stockNewValue = (
        previousYearStats.stocks + 
        thisYearContributionToStocks + 
        (isRetired ? (-previousYearStats.stocks * retirementRule.percents) : 0)
      ) * (1 + portfolioDiversity.stocks.growth);

      salary *= salaryYearlyGrowth;
      salary = Math.round(salary);

      monthlyExpenses *= expensesYearlyGrowth;
      monthlyExpenses = Math.round(monthlyExpenses);

      if (changedSalary[i] !== undefined) {
        salary = changedSalary[i];
      }

      const totalBalance = remainingCash + bondsNewValue + stockNewValue;

      preds.push({
        year: i,
        totalBalance: Math.floor(totalBalance),
        cash: Math.floor(remainingCash),
        stocks: Math.floor(stockNewValue),
        bonds: Math.floor(bondsNewValue),
        expenseThisYear: monthlyExpenses * 12,
      });
    }

    return preds;
  };

  render() {
    const { time } = this.props;
    const nowDate = new Date();
    const nowYear = nowDate.getFullYear();
    const predictions = this.getPredictedData(nowYear, time);

    return (
      <ResponsiveContainer width="100%" height={400}>
        <LineChart data={predictions} margin={chartMargin}>
          <XAxis dataKey="year" />
          <YAxis />
          <CartesianGrid strokeDasharray="3 3" />
          <Tooltip />
          <Legend />
          <Line dot={false} type="monotone" dataKey="totalBalance" stroke="#8884d8" />
          <Line dot={false} type="monotone" dataKey="cash" stroke="red" />
          <Line dot={false} type="monotone" dataKey="stocks" stroke="orange" />
          <Line dot={false} type="monotone" dataKey="bonds" stroke="blue" />
        </LineChart>
      </ResponsiveContainer>
    );
  }
}

MoneyPrediction.propTypes = propTypes;
MoneyPrediction.defaultProps = defaultProps;

export default MoneyPrediction;
